import React, { useState, useCallback } from "react";
import "../constants/styles/physicianPage.scss";
import { PASSKEY } from "../constants/textContent";
import SummaryTranscript from "./SummaryTranscript";
import SmartToyRoundedIcon from "@mui/icons-material/SmartToyRounded";

function PhysicianPage() {
    const [passkey, setPasskey] = useState("");
    const [loginIsOpen, setLoginIsOpen] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [encounterNumberQuery, setEncounterNumberQuery] = useState("");
    const [searchResults, setSearchResults] = useState({});

    const handleLogin = async (event) => {
        event.preventDefault();
        if (passkey === PASSKEY) {
            console.log("Login Successful!");
            setLoginIsOpen(false);
            setErrorMessage("");
        } else {
            setErrorMessage("Invalid passkey");
        }
        setPasskey("");
    };

    // Hash function to convert encounter number into patient ID
    const hashInputValue = async (input) => {
        const encoder = new TextEncoder();
        const data = encoder.encode(input);
        const hashBuffer = await crypto.subtle.digest("SHA-256", data);
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // Convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // Convert bytes to hex string
        console.log(hashHex);
        return hashHex;
    };

    const onSearch = useCallback(async () => {
        console.log("Searching for encounter number: ", encounterNumberQuery);

        if (!encounterNumberQuery.trim()) return;
        const patientID = await hashInputValue(encounterNumberQuery.trim());

        try {
            const response = await fetch(
                "https://www.cs.toronto.edu/~brli/intakebot/api/getUserSummary",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        user: patientID, // If you want to test, use "123"
                    }),
                }
            );
            if (!response.ok) {
                throw new Error(`${response.status}`);
            }

            const data = await response.json();
            console.log("DATA", data);
            if (
                data["narrative summary"] === "" &&
                data["key information"].length === 0 &&
                data["complete"] === "false"
            ) {
                alert("No summary was found with this encounter number.");
            }
            setSearchResults(data);
        } catch (error) {
            console.error(`${error}`);
        } finally {
            console.log("User Summary Retrieved");
        }
    });

    const handleSearchChange = (event) => {
        setEncounterNumberQuery(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        onSearch(encounterNumberQuery);
    };

    return (
        <>
            <div className='header'>
                <div className='logo-space'>
                    <SmartToyRoundedIcon className='bot-icon' />
                    <h1 className='logo'>Intake ChatBot</h1>
                </div>
            </div>
            <div className='container'>
                {loginIsOpen ? (
                    // Login Page (should be moved to a new React Element)
                    <div className='popup'>
                        <h2 className='login-header'>Login</h2>
                        <form onSubmit={handleLogin}>
                            <div className='search-container'>
                                <label
                                    className='search-label'
                                    htmlFor='password'
                                >
                                    Passkey:
                                </label>
                                <input
                                    className='search-bar'
                                    type='password'
                                    id='password'
                                    value={passkey}
                                    onChange={(e) => setPasskey(e.target.value)}
                                    required
                                />
                                {errorMessage && (
                                    <p className='error-message'>
                                        {errorMessage}
                                    </p>
                                )}
                            </div>
                            <div className='login-button-container'>
                                <button className='login-button' type='submit'>
                                    Login
                                </button>
                            </div>
                        </form>
                    </div>
                ) : (
                    // Physician View Page (should be moved to a new React Element)
                    <div className='physician-view'>
                        <div className='left-panel'>
                            <form
                                onSubmit={handleSubmit}
                                className='search-form'
                            >
                                <label
                                    className='search-label'
                                    htmlFor='encounter-search'
                                >
                                    Encounter Number:
                                </label>
                                <input
                                    className='search-bar'
                                    type='text'
                                    id='encounter-search'
                                    value={encounterNumberQuery}
                                    onChange={handleSearchChange}
                                    placeholder='Enter encounter number...'
                                    required
                                />
                                <button className='search-button' type='submit'>
                                    Search
                                </button>
                            </form>
                        </div>
                        <div className='search-results-container'>
                            <SummaryTranscript summaryData={searchResults} />
                            {
                                // Source tracing would go here. It would be next to the Summary Transcript
                            }
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default PhysicianPage;
